import { getIsApp } from '../../../../modules/AppInfo';
import {
  isAnonymous,
  ShareChannelFactory,
  ShareChannelMap,
  ShareProvider,
  ShareTarget,
  socialSharing,
} from '../../../../modules/share';
import { IS_MINE_MESSAGE } from '../constants';
import { providerAtSalon } from './helpers';

export const generateSmsUrl = (to, body) => {
  let url = 'sms:';

  if (to) {
    url += to;
  }

  if (body) {
    // Specially crafted to work on iOS and Android. The semicolon ends the list of phone numbers
    // while he ampersand is used on iOS and the question mark is used on Android as the start
    // of the sequence to add a body. All together this works cross platform.
    url += `;?&body=${encodeURIComponent(body)}`;
  }

  return url;
};

// Note: Ported the following from socialShare.js with `scope`, `element`, `assignUrl` removed
const getClickHandler = (
  attrs: { body: string },
  onSuccess: () => void,
  onFail: (err: string) => void,
) => {
  // Not: "SMS not supported" check is done externally - if we get here, it's considered supported

  if (getIsApp() && socialSharing()) {
    // Note: Returning the callback instead of attaching to a `element.click` call here
    return () => {
      socialSharing().shareViaSMS(
        attrs.body,
        null,
        onSuccess,
        onFail,
      );
    };
  }

  // Note: Return a "link clicked" callback instead of updating the `href` on attribute changes
  return () => {
    try {
      window.open(generateSmsUrl(undefined, attrs.body));
    } catch (ex) {
      if (onFail) {
        onFail(ex);
      }
    }
  };
};

const shareTextFunc = {
  [ShareTarget.PROFILE]: (provider, url: string): string => (
    `I think you'll like ${providerAtSalon(provider)}. You can book an appointment online at ${url}`
  ),
  [ShareTarget.PLATFORM]: (_, url: string): string => (
    `I think you'll like StyleSeat. You can book an appointment online at ${url}`
  ),
};

const getShareText = (
  url: string,
  content: string,
  isMine?: boolean,
  customText?: string,
) => {
  if (customText) {
    return `${customText} ${url}`;
  }

  if (isMine) {
    return `${IS_MINE_MESSAGE} ${url}`;
  }

  return content;
};

const profileShare: ShareChannelFactory<ShareProvider | null> = (
  provider,
  url,
  user,
  onSuccess,
  onFail,
  message = {},
) => {
  let content: string;
  let isMine: boolean;
  if (provider) {
    isMine = !isAnonymous(user) && provider.id === user.provider_id;
    content = shareTextFunc[ShareTarget.PROFILE](provider, url);
  } else {
    isMine = false;
    content = shareTextFunc[ShareTarget.PLATFORM](provider, url);
  }

  const body = getShareText(url, content, isMine, message.text);

  const attrs = {
    body,
  };

  return getClickHandler(attrs, onSuccess, onFail);
};

const MAP: ShareChannelMap = {
  [ShareTarget.PROFILE]: profileShare,
  [ShareTarget.SEARCH]: profileShare,
  [ShareTarget.PLATFORM]: profileShare,
};

export default MAP;
